import Common from './modules/_common'
import Index from './modules/_index'
import Product from './modules/_product'
import Content from './modules/_content'
import Store from './modules/_store'
import Contact from './modules/_contact'
import Account from './modules/_account'

import Modal from './classes/Modal'

//import Drawer from './classes/Drawer';
//import axios from 'axios';
//import {TweenLite} from 'gsap/TweenMax';
//import simpleParallax from 'simple-parallax-js';
//import GLightbox from 'glightbox'
////import swal from 'sweetalert';

var factory = {Index,Product,Content,Store,Contact,Account}

class App {
    constructor() {
        this.common = new Common();
        const bodyId = document.body.id;
        this.bodyId = bodyId.charAt(0).toUpperCase() + bodyId.slice(1);
        this.controller = factory[this.bodyId]||factory["Index"];
        this.modal = new Modal();
    }

    init(element = document.body) {
        this.common.init(element);
        this.loadEvents(element);
        this.common.finalize(element);
    }

    fire(funcname, element) {
        if (typeof this.controller.prototype[funcname] == 'function'){
            this.controller.prototype[funcname](element);
        }
    }

    loadEvents(element) {
        this.fire("init");
        [...document.body.classList].forEach((classnm) =>{
            this.fire(classnm, element);
        });
        this.fire("finalize");
    }
}

document.addEventListener("DOMContentLoaded",()=>{ 
    window.App = new App();
    window.App.init();
});


/*class App {
    constructor() {

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

        this.initCommon();
        this.initParallax();
        if (document.body.classList.contains('index')) {
            this.page = new Index();
            this.page.initPage();
        }
        if(document.body.classList.contains('productDetail')){
            this.page = new ProductDetail();
            this.page.initPage();
        }
        if(document.body.classList.contains('contact')){
            this.page = new Contact();
            this.page.initPage();
        }
        //console.log("Hello");
    }

    initCommon() {
        this.toggleHeader();

        this.live('button[data-drawer]','click',function(event,target) {
            window.App.drawer.open(event,target);
        });

        document.querySelector('body').addEventListener('click',function(event){
            if(event.target.classList.contains('overlay')){
                window.App.drawer.close();
            }
        });

        window.addEventListener('scroll', function() {
            window.App.toggleHeader()
        });

        this.drawer = new Drawer();
    }

    toggleHeader() {
        if(window.scrollY>0){
            document.querySelector('header').classList.add('collapsed');
        }else {
            document.querySelector('header').classList.remove('collapsed');
        }
    }

    initParallax() {

    }

    afterInit() {

    }


    live (selector, event, handler) {
        document.addEventListener(event, function(evt){
            var target = evt.target;
            while (target != null){
                var isMatch = target.matches(selector);
                
                if (isMatch){
                    evt.stopImmediatePropagation();
                    handler(evt,target);
                    return false;
                }
                
                target = target.parentElement;
            }
        },true);
    }



}

document.addEventListener("DOMContentLoaded",()=>{
    window.App = new App()
    //window.App.afterInit();
});
*/